import { skapaRecept } from './recipeParser.js'

/**
 * Här lägger du in dina recept som helt vanlig text!
 * 
 * Du behöver bara skriva:
 * - Titel, Kategori, Tid, Portioner etc.
 * - "Ingredienser:" följt av ingredienserna (en per rad, t.ex. "2.5 dl vetemjöl")
 * - "Instruktioner:" eller "Gör så här:" följt av stegen (ett per rad)
 * - Frivilligt: "Tips:" och "Bild:"
 */

export const recipes = [
  skapaRecept(`
    Titel: Bästa Pannkaksreceptet
    Kategori: pannkakor
    Beskrivning: När man lagar pannkakor är det några saker man måste tänka på för att lyckas. En Varm panna, låt pannan bli riktigt varm innan du börjar steka. Smör, spelar ingen roll om du bantar eller använder teflonpanna, pannkakor ska stekas i smör. Och till sist, stressa inte. Goda pannkakor är lagade med omsorg. Häll i smeten försiktigt i pannan och ha tålamod så du inte vänder dom för tidigt.
    Tid: 35 min
    Förberedelse: 15 min
    Tillagning: 20 min
    Portioner: 2
    Svårighetsgrad: Lätt
    Bild: https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?auto=format&fit=crop&w=800&q=80
    Tips: För extra frasiga kanter, se till att stekpannan är ordentligt varm innan du häller i smeten!

    Ingredienser:
    3 ägg
    3 dl vetemjöl
    6 dl mjölk (Gärna fetare mjölk)
    1½ tsk salt

    Instruktioner:
    1. Häll upp mjölken i en stor bunke. Slå i äggen. Vispa ut äggen lite i mjölken. Lägg i saltet. Tillsätt mjölet, vispa ner mjölet lite i taget tills du fått en jämn fin smet. 
    2. Stek i varm panna med smör. Vänd pannkakan när smetan stelnat på ovansidan. Om du upplever att pannkakorna fastnar i pannan kan du smälta 1 msk smör och tillsätta i smeten.
    3. Pannkakorna serveras förslagsvis med sylt, grädde, socker, bär. Det kan även vara gott med "matigare" fyllning såsom svampstuvning, pesto, ost, skinka etc. Bara fantasin sätter stopp. Våga testa!
  `),

  skapaRecept(`
    Titel: Mild och krämig indisk gryta - Vegan
    Kategori: indiskt
    Beskrivning: Den här indisk-inspirerade grytan är i min mening VÄLDIGT god och lätt att göra! Såsen är mild och krämig, med smak av indiska kryddor. Den påminner om korma eller shai-paneer, men istället för nötter används solrosfrön, som mixas tillsammans med kryddor innan man häller på kokosmjölk. Resultatet blir en mättande sås med fylligare konsistens. Halloumi eller tofu utgör ett bra substitut för den som inte orkar göra paneer, som är den ost man vanligtvis använder i det indiska köket. Väljer man tofu blir detta en vegansk rätt.
    Tid: 60 min
    Förberedelse: 0 min
    Tillagning: 45 min
    Portioner: 4
    Svårighetsgrad: Medel

    Ingredienser:
    2 dl solrosfrön
    3 msk riven färsk ingefära
    2 st vitlöksklyftor (rivna)
    2 msk sirap/honung
    2 msk rapsolja
    3 msk garam masala
    3 tsk spiskummin
    3 tsk Koriander
    1 krm chilipulver
    1 tsk salt
    1 burk krossade tomater (möjligtvis lite mindre)
    1 burk kokosmjölk (möjligtvis lite mindre – prova dig fram)
    400 g halloumi /eller 200 g tofu

    Instruktioner:
    1. Mixa ihop allt i receptet, UTOM tomatkross, kokosmjölk och halloumi, med en stavmixer.
    2. Lägg detta i en kastrull och fräs 3 min i lite olja.
    3. Rör sedan i först tomatkross och sedan cocosmjölk i grytan och låt koka ihop.
    4. Lägg i halloumin eller tofun skuren i bitar ca 2×2 cm och låt allt bli varmt.
    5. Klart! Servera med ris eller indiskt bröd.
  `),

  skapaRecept(`
    Titel: Naan bröd i stekpanna
    Kategori: indiskt
    Beskrivning: Naan bröd i stekpanna, mjukt och fluffigt!.
    Tid: 65 min
    Förberedelse: 40 min
    Tillagning: 25 min
    Portioner: 4
    Svårighetsgrad: Medel

    Ingredienser:
    1,5 dl fingervarmt vatten
    2 tsk strösocker
    2 tsk torrjäst
    4 dl mjöl
    0,5 tsk salt
    2 msk smält smör + extra smör att pensla bröden med i stekpannan
    2 msk yoghurt

    Instruktioner:
    1. Rör ihop jäst, vatten och socker. Låt stå ca 10 min.
    2. Häll i mjöl, salt, smör och yoghurt. Rör ihop till en deg, knåda lite. Låt stå i en övertäckt bunke ca 30 min.
    3. Dela degen i 4 lika stora delar och kavla ut/forma till 4 st platta, avlånga bröd.
    4. Gnid in en stekpanna med en aning smör eller olja och hetta upp den till medelvärme.
    5. Lägg i de utkavlade degbitarna i pannan och grädda 3 – 4 minuter. Brödet ska gärna ”puffa upp sig”. Pensla eventuellt på lite smör på valfria ställen på brödet (dessa fläckar kommer att få extra färg när du vänder brödet).
    6. Vänd brödet och grädda ytterligare 2 – 3 minuter.
    7. Vira in det klara brödet i en varm handduk medan du gräddar de andra.
  `),

  skapaRecept(`
    Titel: Svamp- och färsgryta med pasta
    Kategori: pasta
    Beskrivning: En smakrik gryta med pasta, passar perfekt t.ex. under hösten när man vill ha något som går snabbt att laga, och samtidigt smakar fantastiskt!
    Tid: 45 min
    Förberedelse: 0 min
    Tillagning: 45 min
    Portioner: 4
    Svårighetsgrad: Medel

    Ingredienser:
    500g färs
    1/2 msk olja
    salt
    peppar
    1 gul lök
    250g champinjoner
    2 vitlöksklyfta
    2 1/2 dl vispgrädde
    2 dl mjölk
    1 köttbuljongtärning
    1 msk japansk soja
    1 tsk timjan
    4 port pasta
    65g mâchesallad

    Instruktioner:
    1. Stek färsen i hälften av oljan i en stekpanna och krydda med salt och peppar.
    2. Skala och hacka löken och vitlöken, och hacka svampen och stek i oljan. 
    3. Blanda ihop färsen med löken och svampen, samt tillsätt grädde, mjölk och smulad buljongtärning och sjud i 10 minuter. 
    4. Koka pastan
    5. Klart!
  `),

  skapaRecept(`
    Titel: Hirams skinka
    Kategori: Husmanskost
    Beskrivning: En klassisk rätt att tillaga en jul/helg-skinka, otroligt gott
    Tid: 60 min
    Förberedelse: 0 min
    Tillagning: 60 min
    Portioner: 6-8
    Svårighetsgrad: Lätt

    Ingredienser:
    1 mindre färdigkokt skinka, ca 2kg
    5 dl vispgrädde
    1.5 dl heinz chilisås
    4 tsk curry

    Instruktioner:
    1. Rensa skinkan (Ta bort svålen och eventuella fettbitar).
    2. Sätt ungen på 225 grader.
    3. Skiva upp skinkan i skivor som är cirka 0.5-1 cm tjocka och lägg upp i en stor ungssäker form.
    4. Blanda resterande ingridienser och häll över skinkan så dom badar i såsen. 
    5. Sätt in formen i ugnen i ungefär 45 minuter.
    6. Koka ris
    7. Klart!
  `),
]

export function getRecipeById(id) {
  return recipes.find(recipe => recipe.id === id)
}

export function getRecipesByCategory(categoryId) {
  if (!categoryId || categoryId === 'alla') {
    return recipes
  }
  return recipes.filter(recipe => recipe.category === categoryId)
}
